import { css } from '@emotion/core';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
import { tokens, media } from '@domain-group/fe-brary';
export var title = /*#__PURE__*/css("color:", tokens.colors.neutral.heavy.default, ";", designTokenFonts.heading, ";");
export var sectionDescription = /*#__PURE__*/css("color:", tokens.colors.neutral.heavy.default, ";", designTokenFonts.body, ";margin-top:10px;");
export var agencyMemberships = /*#__PURE__*/css("display:flex;flex-direction:column;padding:32px 15px;gap:32px;", media('>=tablet'), "{flex-direction:row;gap:10px;}", media('>=desktop'), "{padding-left:0;}");
export var agencyMembership = {
  name: "17lgwxv",
  styles: "display:flex;flex-direction:row;gap:10px;align-items:center;margin-top:20px;"
};
export var agencyMembershipCategory = {
  name: "b95f0i",
  styles: "display:flex;flex-direction:column;flex:1;"
};
export var agencyMembershipLogo = {
  name: "1gapyfo",
  styles: "height:60px;"
};
export var agencyMembershipContent = {
  name: "j7qwjs",
  styles: "display:flex;flex-direction:column;"
};
export var membershipName = /*#__PURE__*/css(designTokenFonts.bodyBold, ";");
export var membershipDescription = /*#__PURE__*/css(designTokenFonts.body, ";");